<template>
<ion-page>
  <ion-header :translucent="true">
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button @click="goBack">BACK</ion-button>
      </ion-buttons>
      <ion-title>Picture</ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content class="ion-padding">
    <img src="https://www.seekpng.com/png/detail/844-8444619_student-png-male-student-cartoon-png.png"/>
  </ion-content>
</ion-page>
</template>

<script>
import { defineComponent } from "vue";
import {
  IonPage,
  IonContent,
  IonToolbar,
  IonHeader,
  IonTitle,
  IonButton,
  IonButtons,
} from "@ionic/vue";
export default defineComponent({
  name: "pictureVue",
  components: {
    IonPage,
    IonContent,
    IonToolbar,
    IonHeader,
    IonTitle,
    IonButton,
    IonButtons,
  },
  props: [ "modalNav"],
  setup(props) {
    /**
     * get the nav from the props and go back
     */
    const goBack = () => {
      const nav = props.modalNav.value;
      nav.pop();
    };
    return {
      goBack
    };
  }
});
</script>

<style lang="css" scoped>
</style>